<template>
  <div>
    <vue-element-loading :active="isLoading" />
    <v-card>
      <v-card-title>
        <v-icon color="primary"> mdi-school </v-icon>
        <span class="pl-2">{{ $t('pages.schools') }}</span>
        <v-spacer></v-spacer>
        <create-button @create="showSchoolDialog"></create-button>
      </v-card-title>
      <v-data-table
        item-key="id"
        :loading="isLoading"
        loading-text="Loading... Please wait"
        :headers="headers"
        :items="schools"
        :search="search"
      >
        <template v-slot:top>
          <v-text-field
            v-model="search"
            :lablel="$t('pages.search')"
            class="mx-4"
          ></v-text-field>
        </template>
        <template v-slot:item.created_at="{ item }">
          <small>{{ item.created_at | moment('LL') }}</small> -
          <small class="text-muted">{{ item.created_at | moment('LT') }}</small>
        </template>
        <template v-slot:item.name="{ item }">
          <span
            class="font-weight-medium"
            style="cursor:pointer; color:#1976D2;"
            @click="viewSchool(item)"
          >{{ item.name }}</span>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon x-small color="info" class="mr-1" @click="viewSchool(item)">
                <v-icon small>mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('actions.view') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon x-small color="warning" class="mr-1" @click="editSchool(item)">
                <v-icon small>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('actions.edit') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon x-small color="error" @click="deleteSchool(item, schools.indexOf(item))">
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('actions.delete') }}</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
    <v-row justify="center">
      <v-dialog v-model="schoolDialog" persistent max-width="600px">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card>
            <v-card-title>
              <span class="text-h5">{{ $t('pages.school_data') }}</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="name"
                      :rules="nameRules"
                      :label="$t('forms.name') + '*'"
                      :hint="$t('forms.name_of_the_school')"
                      :readonly="viewOnly"
                      required
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-divider class="my-2"></v-divider>
                    <div class="text-subtitle-2 grey--text text--darken-1 mb-2">
                      <v-icon small class="mr-1">mdi-account-tie</v-icon>
                      Drejtori i Shkollës
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="directorName"
                      label="Emri i Drejtorit"
                      hint="Emri dhe mbiemri"
                      :readonly="viewOnly"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="directorEmail"
                      label="Email i Drejtorit"
                      type="email"
                      hint="Llogaria do të krijohet me fjalëkalim 12345678"
                      :readonly="viewOnly"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field
                      v-model="directorPhone"
                      label="Telefoni i Drejtorit"
                      hint="Opsional"
                      :readonly="viewOnly"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeSchoolDialog">
                {{ $t('actions.close') }}
              </v-btn>
              <v-btn v-if="!viewOnly" color="blue darken-1" text @click="createSchool">
                {{ $t('actions.save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
    </v-row>
  </div>
</template>

<script>
import CreateButton from '@/components/CreateButton.vue';
import VueElementLoading from 'vue-element-loading';

export default {
  components: { CreateButton, VueElementLoading },
  data() {
    return {
      schools: [],
      isLoading: false,
      search: '',
      schoolDialog: false,
      valid: true,
      id: null,
      viewOnly: false,
      name: null,
      directorName: null,
      directorEmail: null,
      directorPhone: null,
      nameRules: [(v) => !!v || this.$t('forms.school_name_is_required')],
      headers: [
        // { text: this.$t('table.id'), value: 'id', align: 'start', filterable: false },
        { text: this.$t('table.name'), value: 'name' },
        { text: this.$t('table.created'), value: 'created_at' },
        { text: this.$t('table.actions'), value: 'actions', sortable: false },
      ],
    };
  },
  mounted() {
    this.loadSchools();
  },
  methods: {
    loadSchools() {
      this.isLoading = true;
      this.schools = [];
      axios
        .get(`/schools/list`)
        .then((response) => {
          this.schools = response.data;
        })
        .catch((error) => {
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error_while_retrieving_schools'),
            type: 'error',
          });
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    validate() {
      return this.$refs.form.validate();
    },
    showSchoolDialog() {
      this.id = null;
      this.viewOnly = false;
      this.schoolDialog = true;
    },
    closeSchoolDialog() {
      this.id = null;
      this.viewOnly = false;
      this.directorName = null;
      this.directorEmail = null;
      this.directorPhone = null;
      this.schoolDialog = false;
      this.$refs.form.reset();
    },
    createSchool() {
      if (this.validate()) {
        this.isLoading = true;
        this.schoolDialog = false;
        axios
          .post(`/schools/create-edit`, {
            id: this.id,
            name: this.name,
            director_name: this.directorName,
            director_email: this.directorEmail,
            director_phone: this.directorPhone,
          })
          .then(() => {
            this.loadSchools();
            this.$notify({
              title: this.$t('messages.success'),
              text: this.id
                ? this.$t('messages.school_updated')
                : this.$t('messages.school_created'),
              type: 'success',
            });
            // this.$swal(
            //   this.$t('messages.success'),
            //   this.id
            //     ? this.$t('messages.school_updated')
            //     : this.$t('messages.school_created'),
            //   'success'
            // );
          })
          .catch((error) => {
            const msg = error?.response?.data?.error?.[0] || this.$t('messages.error_while_creating_bus');
            this.$notify({
              title: this.$t('messages.error'),
              text: msg,
              type: 'error',
            });
            // this.$swal(this.$t('messages.error'), error.response.data.message, 'error');
          })
          .then(() => {
            this.isLoading = false;
          });
      }
    },
    viewSchool(school) {
      this.id = school.id;
      this.name = school.name;
      this.directorName = school.director_name || null;
      this.directorEmail = school.director_email || null;
      this.directorPhone = school.director_phone || null;
      this.viewOnly = true;
      this.schoolDialog = true;
    },
    editSchool(school) {
      this.id = school.id;
      this.name = school.name;
      this.directorName = school.director_name || null;
      this.directorEmail = school.director_email || null;
      this.directorPhone = school.director_phone || null;
      this.viewOnly = false;
      this.schoolDialog = true;
    },
    deleteSchool(school, index) {
      this.$swal
        .fire({
          title: this.$t('messages.delete_school'),
          text:
            this.$t('messages.are_you_sure_to_delete_the_school') +
            " ' " +
            school.name +
            " ' ? " +
            this.$t('messages.you_wont_be_able_to_revert_this') +
            '!',
          icon: 'error',
          showCancelButton: true,
          confirmButtonText: this.$t('messages.yes_delete_it'),
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.deleteSchoolServer(school.id, index);
          }
        });
    },
    deleteSchoolServer(school_id, index) {
      axios
        .delete(`/schools/${school_id}`)
        .then(() => {
          this.schools.splice(index, 1);
          this.$notify({
            title: this.$t('messages.success'),
            text: this.$t('messages.school_deleted'),
            type: 'success',
          });
        })
        .catch(() => {
          this.$notify({
            title: this.$t('messages.error'),
            text: this.$t('messages.error_while_deleting_schools'),
            type: 'error',
          });
          // this.$swal(this.$t('messages.error'), error.response.data.message, 'error');
        })
        .then(() => {
          //this.isDeleting = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped></style>
